// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__90OJA","rootNoMargin":"styles_rootNoMargin__2pMyg"};